export type HistoryColumns = {
  year?: number | string
  month?: number | string
  description?: string
}

export type HistoryListItem = {
  year: number | ''
  month: number | ''
  description: string
  uuid: string
}

function createHistoryUuid(): string {
  const cryptoObj =
    window.crypto || (window as Window & { msCrypto?: Crypto }).msCrypto
  const template = '10000000-1000-4000-8000-100000000000'
  return template.replace(/[018]/g, (c) =>
    (
      Number(c) ^
      (cryptoObj!.getRandomValues(new Uint8Array(1))[0] &
        (15 >> (Number(c) / 4)))
    ).toString(16)
  )
}

function createHistoryListItem(columns?: HistoryColumns): HistoryListItem {
  const cols = columns || {}
  return {
    year: Number(cols.year) || '',
    month: Number(cols.month) || '',
    description: cols.description || '',
    uuid: createHistoryUuid()
  }
}

export function addHistoryListItem(
  historyList: HistoryListItem[],
  index: number | undefined | null,
  columns?: HistoryColumns
): void {
  const newHistoryItem = createHistoryListItem(columns)
  if (typeof index === 'number') {
    historyList.splice(index, 0, newHistoryItem)
  } else {
    historyList.push(newHistoryItem)
  }
}

export function moveHistoryListItem<T>(
  historyList: T[],
  params: { index: number; to: string }
): void {
  const fromIndex = params.index
  const to = params.to
  if (fromIndex === 0 && to === 'up') {
    return
  }
  if (fromIndex + 1 === historyList.length && to === 'down') {
    return
  }
  if (to === 'up') {
    historyList.splice(
      fromIndex - 1,
      2,
      historyList[fromIndex],
      historyList[fromIndex - 1]
    )
    return
  }
  if (to === 'down') {
    historyList.splice(
      fromIndex,
      2,
      historyList[fromIndex + 1],
      historyList[fromIndex]
    )
  }
}
